import { Pipe, PipeTransform } from '@angular/core';
import { MemberSubmission } from '../../../models/submissions/member-submission';
import { SubmissionStatusIdEnum } from '../../../models/enum/shared/submission-status-id.enum';
import { DateUtils } from '../../../utils/date-utils';
import { EpEmployerSubmission } from '../../../models/submissions/employer-submissions/ep-employer-submission';

@Pipe({
  name: 'submissionStatusDate'
})
export class SubmissionStatusDatePipe implements PipeTransform {
  transform(submission: MemberSubmission | EpEmployerSubmission): string {
    if (!submission) return '';
    const date =
      submission.statusId === SubmissionStatusIdEnum.Completed
        ? submission.completedDate
        : submission.lastStatusUpdateDate;
    return date ? DateUtils.formatISOStringToCurrentDateTime(date) : '';
  }
}
